import { apiClient } from '../client';
import type { ApiAsyncTask } from './types';

export interface RetryAsyncTaskResponse {
  async_task: ApiAsyncTask;
}

export async function retryAsyncTask(id: number): Promise<RetryAsyncTaskResponse> {
  const response = await apiClient.post<RetryAsyncTaskResponse>(
    `/api/async_tasks/${id}/retry`
  );
  return response.data;
}
